import {
    ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL,
    ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL,
    ACTIVATE_CAMERA_SIM_CARD_REQUEST,
    ACTIVATE_CAMERA_SIM_CARD_RESULT,
    ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES,
} from "Redux/actionTypes";

export const activateCameraSimCardOpenModal = (items) => ({
    type: ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL,
    payload: items
})

export const activateCameraSimCardCloseModal = () => ({
    type: ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL
})

export const activateCameraSimCardRequest = (data) => ({
    type: ACTIVATE_CAMERA_SIM_CARD_REQUEST,
    payload: data
})

export const activateCameraSimCardResult = (result) => ({
    type: ACTIVATE_CAMERA_SIM_CARD_RESULT,
    payload: result
})

export const activateCameraSimCardUpdateDevices = (items) => ({
    type: ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES,
    payload: items
})